// hubs object includes the entry point and urls of each hub that uses this template.
const hubs = {
  en: 'hub.6sense.com/', //http
};

const devOptions = {
  shortHubUrl: hubs.en, //change me to the base url of your hub (no http(s) or www)
  fullHubUrl: `https://${hubs.en}` + '?ufcc_onbrand_local', //exact url to access hub, leave onbrand query string
  cihostFolder: '6sense-multi', //change me to the cihost folder name
  remindMeToGit: true,
  notifyOnBuildSuccess: true, //Gives a (slightly annoying?) message whenever a build completes successfully
};

module.exports = devOptions;



// WEBPACK FOOTER //
// ./dev-options.js